import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { KBLinks } from 'features/constants';
import { FC } from 'react';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import PageHeader from 'ui-kit/components/headers/PageHeader';
import LoadingSpinner from 'ui-kit/components/LoadingSpinner';
import ContentContainer from 'ui-kit/components/utility/ContentContainer';
import { MAX_ITEMS_LIMIT } from '../constants';
import TransfereeAccordion from './components/TransfereeAccordion';
import { TransfereeInformationComponentProps } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordionContainer: {
      width: '100%',
      padding: theme.spacing(0, 3, 3),
    },
  }),
);
const TransfereeInformationContent: FC<TransfereeInformationComponentProps> = ({
  transferees,
  loadingStatus,
  onAddTransferee,
  onUpdateTransferee,
  onDeleteTransferee,
  validationErrors,
  clearValidationErrors,
  isReadOnly = false,
}) => {
  const classes = useStyles();

  return (
    <div
      style={{ pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}
      tabIndex={isReadOnly ? -1 : undefined}
      onKeyDown={(e) => isReadOnly && e.preventDefault()}
    >
      <ContentContainer fullWidth mTop="0">
        <PageHeader
          title="Transferee Information"
          subtitle="The report must include information about the transferee entity and/or trust involved. Multiple transferees may be recorded."
          menuItems={[
            {
              label: 'Knowledge Base',
              link: KBLinks.fincenReport,
            },
          ]}
          divider={true}
          contentRight={
            <AgentNetButton
              color="primary"
              size="small"
              variant="contained"
              data-testid="fincen-transferee-add-button"
              onClick={onAddTransferee}
              plusIcon
              disabled={transferees.length >= MAX_ITEMS_LIMIT}
            >
              Add Transferee
            </AgentNetButton>
          }
        />
        <LoadingSpinner
          status={loadingStatus === 'loading' || loadingStatus === 'saving' ? 'loading' : 'idle'}
          variant="linear"
        />

        <div className={classes.accordionContainer}>
          {transferees.map((transferee, index) => (
            <TransfereeAccordion
              key={transferee.id || index}
              transferee={transferee}
              index={index}
              onUpdate={onUpdateTransferee}
              onDelete={transferees.length > 1 ? onDeleteTransferee : undefined}
              validationErrors={validationErrors}
              clearValidationErrors={clearValidationErrors}
            />
          ))}
        </div>
      </ContentContainer>
    </div>
  );
};
export default TransfereeInformationContent;
